module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Undertaking Summary"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [(_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('fieldset', {
    attrs: {
      "disabled": _vm.formDisabled
    }
  }, [(!_vm.loading) ? _c('form', {
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "undertaking"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("DB Number")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.undertaking.dbNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('undertaking.name')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Undertaking Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.name),
      expression: "undertaking.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "aria-required": "true"
    },
    domProps: {
      "value": (_vm.undertaking.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.undertaking, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('undertaking.name')),
      expression: "errors.has('undertaking.name')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Undertaking Name is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('undertaking.agencyId')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Lead Agency")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.agencyId),
      expression: "undertaking.agencyId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "agencyId",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.undertaking, "agencyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select an Agency")]), _vm._v(" "), _vm._l((_vm.agencyOrgList), function(agency) {
    return _c('option', {
      key: agency.id,
      domProps: {
        "value": agency.id
      }
    }, [_vm._v(_vm._s(agency.description))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('undertaking.agencyId')),
      expression: "errors.has('undertaking.agencyId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Lead Agency is required")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedLeadAgency && _vm.selectedLeadAgency.hasUsers === false && !_vm.selectedLeadAgency.agencyNoReview),
      expression: "selectedLeadAgency && selectedLeadAgency.hasUsers === false && !selectedLeadAgency.agencyNoReview"
    }],
    staticClass: "has-error"
  }, [_vm._v("\n                                    Selected Lead Agency has no Wyotrack users\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Agency Undertaking No")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.agencyUndertakingNo),
      expression: "undertaking.agencyUndertakingNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "agencyUndertakingNo"
    },
    domProps: {
      "value": (_vm.undertaking.agencyUndertakingNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.undertaking, "agencyUndertakingNo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Number of Undertaking Actions")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.numberOfActions),
      expression: "undertaking.numberOfActions"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "numberOfActions"
    },
    domProps: {
      "value": (_vm.undertaking.numberOfActions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.undertaking, "numberOfActions", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('undertaking.reqMoa') || _vm.errors.has('undertaking.reqPa')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Requirements")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.reqMoa),
      expression: "undertaking.reqMoa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.moaPaValidationRule(_vm.undertaking.reqPa)),
      expression: "moaPaValidationRule(undertaking.reqPa)"
    }],
    attrs: {
      "disabled": _vm.undertaking.reqPa,
      "id": "reqMoaCheckbox",
      "type": "checkbox",
      "name": "reqMoa"
    },
    domProps: {
      "checked": Array.isArray(_vm.undertaking.reqMoa) ? _vm._i(_vm.undertaking.reqMoa, null) > -1 : (_vm.undertaking.reqMoa)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.undertaking.reqMoa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.undertaking.reqMoa = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.undertaking.reqMoa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.undertaking, "reqMoa", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "reqMoaCheckbox"
    }
  }, [_vm._v("MOA")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.reqPa),
      expression: "undertaking.reqPa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.moaPaValidationRule(_vm.undertaking.reqMoa)),
      expression: "moaPaValidationRule(undertaking.reqMoa)"
    }],
    attrs: {
      "disabled": _vm.undertaking.reqMoa,
      "id": "reqPaCheckbox",
      "type": "checkbox",
      "name": "reqPa"
    },
    domProps: {
      "checked": Array.isArray(_vm.undertaking.reqPa) ? _vm._i(_vm.undertaking.reqPa, null) > -1 : (_vm.undertaking.reqPa)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.undertaking.reqPa,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.undertaking.reqPa = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.undertaking.reqPa = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.undertaking, "reqPa", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "reqPaCheckbox"
    }
  }, [_vm._v("PA")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.reqDiscoveryPlan),
      expression: "undertaking.reqDiscoveryPlan"
    }],
    attrs: {
      "id": "reqDiscoveryPlanCheckbox",
      "type": "checkbox",
      "name": "reqDiscoveryPlan"
    },
    domProps: {
      "checked": Array.isArray(_vm.undertaking.reqDiscoveryPlan) ? _vm._i(_vm.undertaking.reqDiscoveryPlan, null) > -1 : (_vm.undertaking.reqDiscoveryPlan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.undertaking.reqDiscoveryPlan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.undertaking.reqDiscoveryPlan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.undertaking.reqDiscoveryPlan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.undertaking, "reqDiscoveryPlan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "reqDiscoveryPlanCheckbox"
    }
  }, [_vm._v("Discovery Plan")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.reqDataDiscoveryPlan),
      expression: "undertaking.reqDataDiscoveryPlan"
    }],
    attrs: {
      "id": "reqDataDiscoveryPlanCheckbox",
      "type": "checkbox",
      "name": "reqDataDiscoveryPlan"
    },
    domProps: {
      "checked": Array.isArray(_vm.undertaking.reqDataDiscoveryPlan) ? _vm._i(_vm.undertaking.reqDataDiscoveryPlan, null) > -1 : (_vm.undertaking.reqDataDiscoveryPlan)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.undertaking.reqDataDiscoveryPlan,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.undertaking.reqDataDiscoveryPlan = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.undertaking.reqDataDiscoveryPlan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.undertaking, "reqDataDiscoveryPlan", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "reqDataDiscoveryPlanCheckbox"
    }
  }, [_vm._v("Data Discovery Plan")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('undertaking.reqPa') || _vm.errors.has('undertaking.reqMoa')),
      expression: "errors.has('undertaking.reqPa') || errors.has('undertaking.reqMoa')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Cannot check off both MOA and PA")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.reqVisualContrastRating),
      expression: "undertaking.reqVisualContrastRating"
    }],
    attrs: {
      "id": "reqVisualContrastRatingCheckbox",
      "type": "checkbox",
      "name": "reqVisualContrastRating"
    },
    domProps: {
      "checked": Array.isArray(_vm.undertaking.reqVisualContrastRating) ? _vm._i(_vm.undertaking.reqVisualContrastRating, null) > -1 : (_vm.undertaking.reqVisualContrastRating)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.undertaking.reqVisualContrastRating,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.undertaking.reqVisualContrastRating = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.undertaking.reqVisualContrastRating = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.undertaking, "reqVisualContrastRating", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "reqVisualContrastRatingCheckbox"
    }
  }, [_vm._v("Visual Contrast Rating")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.reqComplianceCheck),
      expression: "undertaking.reqComplianceCheck"
    }],
    attrs: {
      "id": "reqComplianceCheckCheckbox",
      "type": "checkbox",
      "name": "reqComplianceCheck"
    },
    domProps: {
      "checked": Array.isArray(_vm.undertaking.reqComplianceCheck) ? _vm._i(_vm.undertaking.reqComplianceCheck, null) > -1 : (_vm.undertaking.reqComplianceCheck)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.undertaking.reqComplianceCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.undertaking.reqComplianceCheck = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.undertaking.reqComplianceCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.undertaking, "reqComplianceCheck", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "reqComplianceCheckCheckbox"
    }
  }, [_vm._v("Compliance Check")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.reqHabsHaerRecord),
      expression: "undertaking.reqHabsHaerRecord"
    }],
    attrs: {
      "id": "reqHabsHaerRecordCheckbox",
      "type": "checkbox",
      "name": "reqHabsHaerRecord"
    },
    domProps: {
      "checked": Array.isArray(_vm.undertaking.reqHabsHaerRecord) ? _vm._i(_vm.undertaking.reqHabsHaerRecord, null) > -1 : (_vm.undertaking.reqHabsHaerRecord)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.undertaking.reqHabsHaerRecord,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.undertaking.reqHabsHaerRecord = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.undertaking.reqHabsHaerRecord = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.undertaking, "reqHabsHaerRecord", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "reqHabsHaerRecordCheckbox"
    }
  }, [_vm._v("HABS/HAER Record")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('undertaking.effectId')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Finding of Effect for Project")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.effectId),
      expression: "undertaking.effectId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "effectId",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.undertaking, "effectId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.effectList), function(effect) {
    return _c('option', {
      key: effect.effectId,
      domProps: {
        "value": effect.effectId
      }
    }, [_vm._v("\n                                        " + _vm._s(effect.description) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('undertaking.effectId')),
      expression: "errors.has('undertaking.effectId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Finding of Effect is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Finding of Effect Notes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.findingOfEffectNotes),
      expression: "undertaking.findingOfEffectNotes"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "name": "findingOfEffectNotes"
    },
    domProps: {
      "value": (_vm.undertaking.findingOfEffectNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.undertaking, "findingOfEffectNotes", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Inventory Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.inventoryType),
      expression: "undertaking.inventoryType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "inventoryType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.undertaking, "inventoryType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.inventoryTypeList), function(type) {
    return _c('option', {
      key: type.id,
      domProps: {
        "value": type.id
      }
    }, [_vm._v("\n                                        " + _vm._s(type.description) + "\n                                    ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('undertaking.reviewFrameworkId')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Review Framework")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.reviewFrameworkId),
      expression: "undertaking.reviewFrameworkId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "reviewFrameworkId",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.undertaking, "reviewFrameworkId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.reviewFrameworkList), function(framework) {
    return _c('option', {
      key: framework.id,
      domProps: {
        "value": framework.id
      }
    }, [_vm._v("\n                                        " + _vm._s(framework.description) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('undertaking.reviewFrameworkId')),
      expression: "errors.has('undertaking.reviewFrameworkId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Review framework is required")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('undertaking.reviewTimeframeId')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Review Timeframe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.reviewTimeframeId),
      expression: "undertaking.reviewTimeframeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "reviewTimeframeId",
      "aria-required": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.undertaking, "reviewTimeframeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.reviewTfFilteredList), function(timeframe) {
    return _c('option', {
      key: timeframe.id,
      domProps: {
        "value": timeframe.id
      }
    }, [_vm._v("\n                                        " + _vm._s(timeframe.description) + "\n                                    ")])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('undertaking.reviewTimeframeId')),
      expression: "errors.has('undertaking.reviewTimeframeId')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Review timeframe is required")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.undertaking.reviewTimeframeId),
      expression: "undertaking.reviewTimeframeId"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("PLSS Location")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button3",
      "disabled": !_vm.undertaking.undertakingId
    },
    on: {
      "click": function($event) {
        _vm.$refs['plssLocationModal'].open()
      }
    }
  }, [_vm._v("Add PLSS Locations")]), _vm._v(" "), _c('modal', {
    ref: "plssLocationModal",
    attrs: {
      "title": "Add Sections(s)"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h4', [_vm._v("Add PLSS Locations")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('plssComponent', {
    ref: "plssComponent",
    attrs: {
      "showTitle": false
    },
    on: {
      "savePlss": _vm.savePlss
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$refs['plssLocationModal'].close()
      }
    }
  }, [_vm._v("Close")])])])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.undertaking.reviewTimeframeId),
      expression: "undertaking.reviewTimeframeId"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Section List")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.plssLocationGridSpec.tableData,
      "columns": _vm.plssLocationGridSpec.columns,
      "options": _vm.plssLocationGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deletePlssLocation(props.row.undertakingPlssLocationId)
            }
          }
        })])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Stipulations")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.stipulations),
      expression: "undertaking.stipulations"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "name": "stipulations"
    },
    domProps: {
      "value": (_vm.undertaking.stipulations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.undertaking, "stipulations", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.undertaking.comment),
      expression: "undertaking.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "name": "comments"
    },
    domProps: {
      "value": (_vm.undertaking.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.undertaking, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(_vm._s(_vm.investigationTableLabel))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.undertaking.undertakingId,
      "type": "button",
      "name": "assignInvestigation"
    },
    on: {
      "click": function($event) {
        _vm.$refs['investigationAssignModal'].open()
      }
    }
  }, [_vm._v("Assign Investigation")]), _vm._v(" "), _c('modal', {
    ref: "investigationAssignModal"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Assign An Investigation")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['investigationAssignModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loadAllInvestigations($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "searchDbNumber"
    }
  }, [_vm._v("DB Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invSearchDto.dbNumber),
      expression: "invSearchDto.dbNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchDbNumber"
    },
    domProps: {
      "value": (_vm.invSearchDto.dbNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invSearchDto, "dbNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "searchReportTitle"
    }
  }, [_vm._v("Report Title")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invSearchDto.reportTitle),
      expression: "invSearchDto.reportTitle"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchReportTitle"
    },
    domProps: {
      "value": (_vm.invSearchDto.reportTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invSearchDto, "reportTitle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "searchAgencyNumber"
    }
  }, [_vm._v("Agency Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invSearchDto.agencyNumber),
      expression: "invSearchDto.agencyNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchAgencyNumber"
    },
    domProps: {
      "value": (_vm.invSearchDto.agencyNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invSearchDto, "agencyNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("Search")])])])]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.invAllGridSpec.tableData,
      "columns": _vm.invAllGridSpec.columns,
      "options": _vm.invAllGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "assign",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn",
          on: {
            "click": function($event) {
              _vm.assignInvestigation(props.row)
            }
          }
        }, [_vm._v("Assign")])])]
      }
    }, {
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/Investigation/' + props.row.investigationId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }, {
      key: "hasUndertaking",
      fn: function(props) {
        return [(props.row.undertakingId) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          attrs: {
            "to": {
              path: '/Undertaking/' + props.row.undertakingId
            },
            "tag": "a"
          }
        }, [_vm._v(_vm._s(props.row.undertakingDbu))])], 1) : _vm._e()]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['investigationAssignModal'].close()
      }
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.invGridSpec.tableData,
      "columns": _vm.invGridSpec.columns,
      "options": _vm.invGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/Investigation/' + props.row.investigationId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }, {
      key: "remove",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn",
          on: {
            "click": function($event) {
              _vm.removeInvestigation(props.row)
            }
          }
        }, [_vm._v("Remove")])])]
      }
    }])
  })], 1)]), _vm._v(" "), (_vm.undertaking.reqMoa || _vm.moaAllGridSpec.tableData.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Assigned MOA")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.undertaking.undertakingId,
      "type": "button",
      "name": "assignMoa"
    },
    on: {
      "click": function($event) {
        _vm.$refs['moaAssignModal'].open()
      }
    }
  }, [_vm._v("Assign MOA")]), _vm._v(" "), _c('modal', {
    ref: "moaAssignModal"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Assign An MOA")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['moaAssignModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {}, [_c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/Moa",
      "tag": "button"
    }
  }, [_vm._v("Create New MOA")])], 1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.searchMoas($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "searchDbNumber"
    }
  }, [_vm._v("Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moaSearchDto.name),
      expression: "moaSearchDto.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchDbNumber"
    },
    domProps: {
      "value": (_vm.moaSearchDto.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moaSearchDto, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "searchReportTitle"
    }
  }, [_vm._v("DB Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moaSearchDto.dbNumber),
      expression: "moaSearchDto.dbNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchReportTitle"
    },
    domProps: {
      "value": (_vm.moaSearchDto.dbNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moaSearchDto, "dbNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("Search")])])])]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.moaAllGridSpec.tableData,
      "columns": _vm.moaAllGridSpec.columns,
      "options": _vm.moaAllGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "assign",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn",
          on: {
            "click": function($event) {
              _vm.assignMoa(props.row)
            }
          }
        }, [_vm._v("Assign")])])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {}, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['moaAssignModal'].close()
      }
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.assignedMoa,
      "columns": _vm.moaGridSpec.columns,
      "options": _vm.moaGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/Moa/' + props.row.moaId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }, {
      key: "remove",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn",
          on: {
            "click": function($event) {
              _vm.removeMoa(props.row)
            }
          }
        }, [_vm._v("Remove")])])]
      }
    }])
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.undertaking.reqPa || _vm.paAllGridSpec.tableData.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Assigned PA")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.undertaking.undertakingId,
      "type": "button",
      "name": "assignMoa"
    },
    on: {
      "click": function($event) {
        _vm.$refs['paAssignModal'].open()
      }
    }
  }, [_vm._v("Assign PA")]), _vm._v(" "), _c('modal', {
    ref: "paAssignModal"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Assign An PA")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['paAssignModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {}, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.searchPas($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "searchDbNumber"
    }
  }, [_vm._v("Name")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paSearchDto.name),
      expression: "paSearchDto.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchName"
    },
    domProps: {
      "value": (_vm.paSearchDto.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paSearchDto, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('label', {
    attrs: {
      "for": "searchReportTitle"
    }
  }, [_vm._v("DB Number")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paSearchDto.dbNumber),
      expression: "paSearchDto.dbNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchDbNumber"
    },
    domProps: {
      "value": (_vm.paSearchDto.dbNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.paSearchDto, "dbNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("Search")])])])]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.paAllGridSpec.tableData,
      "columns": _vm.paAllGridSpec.columns,
      "options": _vm.paAllGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "assign",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn",
          on: {
            "click": function($event) {
              _vm.assignPa(props.row)
            }
          }
        }, [_vm._v("Assign")])])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['paAssignModal'].close()
      }
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.assignedPa,
      "columns": _vm.paGridSpec.columns,
      "options": _vm.paGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/Pa/' + props.row.paId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }, {
      key: "remove",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn",
          on: {
            "click": function($event) {
              _vm.removePa(props.row)
            }
          }
        }, [_vm._v("Remove")])])]
      }
    }])
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('validationResultDisplay', {
    attrs: {
      "validationResult": _vm.validationResult
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-offset-2"
  }, [_c('hr'), _vm._v(" "), (!_vm.formDisabled) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "submit",
      "name": "submit"
    },
    on: {
      "click": _vm.saveUndertaking
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.undertakingId ? 'Save' : 'Create') + "\n                                ")]) : _vm._e()])])]) : _vm._e()])], 1)]), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Documents"
    }
  }, [(_vm.$route.params.undertakingId) ? _c('undertakingDocuments', {
    ref: "undertakingDocuments",
    attrs: {
      "parentId": _vm.$route.params.undertakingId,
      "undertaking": _vm.undertaking,
      "loadOnMount": false,
      "formDisabled": _vm.formDisabled,
      "isAdmin": _vm.isAdmin
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('hr'), _vm._v(" "), _c('mediaLetter', {
    ref: "mediaLetter",
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdUndLetter,
      "parentId": _vm.undertakingId,
      "loadOnMount": false
    }
  })], 1)], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Map",
      "disabled": !_vm.undertakingId
    }
  }, [_c('mapx', {
    ref: "mapx",
    attrs: {
      "mediaTypeId": _vm.mediaTypeIdShapeFile,
      "parentId": _vm.undertakingId,
      "loadOnMount": false
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Cultural Resources",
      "disabled": !_vm.showSites
    }
  }, [_c('culturalResourceSelectionUndertaking', {
    ref: "crSelection",
    attrs: {
      "undertaking": _vm.undertaking,
      "loadOnMount": false,
      "isShpo": _vm.checkShpoRole,
      "formDisabled": _vm.formDisabled
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Workflow",
      "disabled": !_vm.undertakingId
    }
  }, [(_vm.undertakingId) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('workflow', {
    ref: "workflow",
    attrs: {
      "workflowId": _vm.undertakingWorkflowId,
      "parentId": _vm.undertakingId
    },
    on: {
      "workflowOnBeforeSubmit": _vm.saveUndertaking,
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.checkShpoRole) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('quickLetter', {
    attrs: {
      "undertakingId": _vm.undertakingId,
      "mediaTypeId": _vm.mediaTypeIdUndLetter,
      "parentId": _vm.undertakingId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.undertakingId) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "undertakingReport",
      "disabled": _vm.reportGenLoading
    },
    on: {
      "click": _vm.genUndertakingReport
    }
  }, [_vm._v("Generate Report")])]) : _vm._e()])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h3', [_vm._v("Undertaking")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c2bf896e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Undertaking.vue
// module id = 992
// module chunks = 1